/**
 * @module Helpers
 */

export default {
  /**
 * helper function
 * @function
 * @param {string} accept - string
 * @returns {string / obj } either string or obj
 */

  /**
   *
   * @param {string} - returns string first letter uppercase
   */
  firstLetterUppercase: string => string[0].toUpperCase() + string.slice(1),

  /**
   * Accept array and returns unique array
   * @param {array} - returns array
   */
  getUniqueArrayItems: arrArg => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) === pos),
  /**
   *
   * @param {*} obj : Accept object
   * @param {*} textKey : key
   * @param {*} textValue : value
   * @param {*} inner : if inner array value
   * @returns text and key obj list from given set of args
   */
  getSelectableValue(obj, textKey, textValue, inner = false) {
    const arr = []
    // eslint-disable-next-line
    for (const item of obj) {
      if (inner) {
        arr.push({
          text: item[inner][textKey],
          value: item[inner][textValue]
        })
      } else {
        arr.push({
          text: item[textKey],
          value: item[textValue]
        })
      }
    }
    return arr
  },
  getSubcategorySelectableValue(obj, textKey, textValue, textParent) {
    let arr = []
    // eslint-disable-next-line
    obj.forEach(item => {
      if(item.parent_category===null){
        arr.push({
          text: item[textKey],
          value: item[textValue],
          parent: item[textParent]
        })

        if(item.subCategory.length>0){
          item.subCategory.forEach(subItem => {
            arr.push({
              text: subItem[textKey],
              value: subItem[textValue],
              parent: subItem[textParent]
            })
          })
        }
      }
    })
    return arr
  },
  /**
   *
   * @param {*} data : Accept object
   * @returns : blank key value of given obj
   */
  setObjValueEmpty(data) {
    // eslint-disable-next-line
    for (const key in data) {
      data[key] = ''
    }
    return data
  },

  /**
   *
   * @param {*} arr array
   * @param {*} fieldKey string
   * Returns [keyfied, keyfield]
   */
  getFieldValueInArray(arr, fieldKey) {
    if (arr.length < 1) {
      return []
    }
    const arrData = []
    arr.map(item => arrData.push(item[fieldKey]))
    return arrData
  },
  /**
   *
   *  Clone array
   */
  copyArray(src) {
    let target = []
    for (let prop in src) {
      if (src.hasOwnProperty(prop)) {
        target[prop] = src[prop]
      }
    }
    return target
  },

  /**
   *
   *  Clone array
   */
  validateSpace(val) {
    if (val) {
      if (val.trim() === '') {
        return false
      } else {
        return true
      }
    }
    return false
  },

  /**
   *
   *  Dont allow more than 2 decimal vals
   */
  priceValidate(val) {
    if (val.indexOf('.') > 0) {
      let exp = val.split('.')
      if (exp[1].length > 2) {
        return val.slice(0, -1)
      }
      return val
    } else if (val.indexOf('.') === 0) {
      return ''
    } else {
      return val
    }
  }

}
